import { Box } from "@mui/material";
import { Outlet } from "react-router-dom";
import CompanyTabs from "./CompanyTabs";

export default function CompanyDetails() {
  return (
    <Box>
      {/* Tabs */}
      <CompanyTabs />

      {/* Tab Content */}
      <Outlet />
    </Box>
  );
}
